import React, { useCallback } from 'react'
import { Box, Button, Checkbox, Text } from '@chakra-ui/react'
import { themeChakra } from '@wow/themes'


interface ICheckboxTyC {
  isRequired: boolean,
  isChecked: boolean,
  onChangeTyC: (e: boolean) => void,
  documentTyC: string,
}

const CheckboxTyC: React.FC<ICheckboxTyC> = ({ isChecked, onChangeTyC, isRequired, documentTyC }) => {

  const handleDownload = useCallback( () => {
    try {
      if (documentTyC) {
        downloadData()
      } else {
        console.error('Se esperaba un Blob pero se recibió:', documentTyC)
      }
    } catch (error) {
      console.error('Error al descargar los términos y condiciones:', error)
    }
  },[documentTyC])


  const downloadData = () => {
    try {
      const binaryString = atob(documentTyC)
      const bytes = new Uint8Array(binaryString.length)
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      const blob = new Blob([bytes], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'TermsAndConditions.pdf')
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error al decodificar la cadena base64:', error)
    }
  }

  const onChange = useCallback( (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeTyC(e.target.checked)
  },[onChangeTyC])
  

  return (
    <Box display='flex' justifyContent='center' data-testid='TyCContainer'>
      <Checkbox
        data-testid='checkboxTyC'
        type='checkbox'
        size='lg'
        marginRight='7px'
        border='1px solid'
        borderRadius='4px'
        color={themeChakra.colors.neutral[90]}
        isChecked={isChecked}
        onChange={onChange}
        isRequired={isRequired}
      />
      <Text color={themeChakra.colors.neutral[90]} textStyle='bodyMd' margin='0 5px' data-testid='textTyC'>Al continuar aceptás los</Text>
      <Button
        variant='link'
        color='primary.100'
        textDecoration='underline'
        data-testid='download-buttonTyC'
        onClick={handleDownload}
      >
        términos y condiciones
      </Button>
    </Box>
  )
}

export default CheckboxTyC